import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { FISCAL_DATA_FRAGMENT } from './fiscalDataFragment';

export const VALUATION_FRAGMENT = gql(
  `
  fragment ValuationFields on Valuation @_unmask {
      exchangeRate
      discountRate
      fairValue
      futurePePercentageChange
      profitMarginPercentageChange
      revenuePercentageChange
      timeframe
      sharesOutstandingGrowthRate
      ...FiscalDataFields
  }
`,
  [FISCAL_DATA_FRAGMENT]
);

export type Valuation = FragmentOf<typeof VALUATION_FRAGMENT>;
